import { useEffect } from "react";
import ProjectTreeDashboard from "./controlPanel/ProjectTreeDashboard";

export default function ProjectDetailControlPanel({ project, projectId, listScope, reportFiles = [],
  reportFilesLoading, loaded, error, onRetry, onReportPreviewRequest, refreshVersion, settingsOpen, onSettingsClose }) {
  const nodeDashboard = Boolean(listScope?.treeFacilityName || listScope?.treePartName);
  useEffect(() => {
    if (!nodeDashboard) onReportPreviewRequest?.();
  }, [onReportPreviewRequest, nodeDashboard]);
  return <section className="projectDetailControlPanel projectDetailControlPanel--open" aria-label="선택 범위 현황">
    <ProjectTreeDashboard projectId={projectId} project={project} listScope={listScope}
      settingsOpen={settingsOpen} onSettingsClose={onSettingsClose}
      files={reportFiles} loading={!loaded && (reportFilesLoading || !error)} error={error} onRetry={onRetry} refreshVersion={refreshVersion} />
  </section>;
}
